import { useCallback, useEffect, useState } from "react";
import { http, formatTRY } from "@/lib/api";
import { toast } from "sonner";

const MONTHS = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
export const toMonthKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
export const shiftMonth = (d, n) => new Date(d.getFullYear(), d.getMonth() + n, 1);
export const monthLabel = (d) => `${MONTHS[d.getMonth()]} ${d.getFullYear()}`;

export const usePayroll = () => {
  const [month, setMonth] = useState(() => shiftMonth(new Date(), 0));
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(null);

  const load = useCallback(async () => {
    const res = await http.get("/payroll", { params: { month: toMonthKey(month) } });
    setData(res.data);
  }, [month]);
  useEffect(() => { load(); }, [load]);

  const run = async (row, confirmText, action, successText) => {
    if (!window.confirm(confirmText)) return;
    setBusy(row.employee_id);
    try {
      await action();
      toast.success(successText);
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Hata"); }
    finally { setBusy(null); }
  };

  const pay = (row) => run(row,
    `${row.employee_name} için ${formatTRY(row.total_payment)} hakediş ödendi olarak işaretlensin mi? Gider kaydı (Maaş) oluşturulacak.`,
    () => http.post("/payroll/pay", { employee_id: row.employee_id, month: toMonthKey(month) }),
    "Hakediş ödendi, gider kaydı oluşturuldu");

  const unpay = (row) => run(row,
    "Ödeme geri alınsın mı? İlgili gider kaydı silinecek.",
    () => http.delete(`/payroll/${row.employee_id}/${toMonthKey(month)}`),
    "Ödeme geri alındı");

  return { month, setMonth, data, busy, pay, unpay };
};
